module.exports = __webpack_public_path__ + "img/map_type_icon.5b748580.svg";